import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TooltipPosition } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ServiceService } from '../service.service';


@Component({
  selector: 'app-previous-records',
  templateUrl: './previous-records.component.html',
  styleUrls: ['./previous-records.component.scss']
})
export class PreviousRecordsComponent implements OnInit {
  previousRecordForm: FormGroup;
  document: any;
  selectedFiles: any;
  Image_Url;
  test=environment.Image_Url +'PatientDocuments';
  base64Image: any;
  documentdetails: any;
  patient_id:any;
  // TooltipPosition: TooltipPosition[] = ['above'];
  // dtOptions = {};
  constructor(private domSanitizer: DomSanitizer, private formBuilder: FormBuilder, private service: ServiceService) {

    this.previousRecordForm = this.formBuilder.group({
      'Doc_Id': [''],
      'Doc_Type_Id_FK': [''],
      'documentname': [''],
      'file': ['']
    });
    this.dataSource.data = this.PeriodicElement;
  }

  PeriodicElement = [
    // {position: 1, DocumentId: '', DocumentType: '', Document: '',DocumentName: '',},
  ];

  displayedColumns: string[] = ['position', 'DocumentId', 'DocumentType', 'DocumentName','Document'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit(): void {

    this.patient_id=localStorage.getItem('patient id');
    //alert(this.patient_id)
    
    this.get_documenttype();
    this.get_document();
    // this.dtOptions = {
    //   // dom: 'lBfrtip',
    //   lengthMenu: [[3, 5, 10, -1], [3, 5, 10, "All"]],
    // }
  }

  // onSelectFile(fileInput: any) {
  //   this.selectedFiles = <File>fileInput.target.files[0];
  //   var reader = new FileReader();
  //   reader.readAsDataURL(fileInput.target.files[0]);
  //   reader.onload = (event: any) => {
  //     this.base64Image = this.domSanitizer.bypassSecurityTrustUrl(event.target.result);
  //     this.Image_Url = this.base64Image
  //     console.log(this.Image_Url)
  //   };
  // }

  get_documenttype() {
    this.service.Get_documentdropdown()
      .subscribe((data) => {
        this.document = data
        console.log(this.document)
      })
  }
  get_document() {
   
    this.service.Get_documentdetail(this.patient_id)
      .subscribe((data) => {
        this.documentdetails = data
        console.log('getdoc',this.documentdetails)
        this.dataSource= new MatTableDataSource(this.documentdetails);
        this.dataSource.paginator=this.paginator;
        this.Image_Url=environment.Image_Url +'PatientDocuments';
      })
  }
  // save_document() {
  //   console.log("chossen file :" +this.selectedFiles)
  //   console.log('PR', this.previousRecordForm.value)
  //   const formData = new FormData();
  //   formData.append('Doc_Type_Id_FK', this.previousRecordForm.value.Doc_Type_Id_FK);
  //   formData.append('documentname', this.previousRecordForm.value.documentname);
  //   formData.append('Choose_Document', this.selectedFiles);
  //   this.service.Insert_document(formData).subscribe((data) => {
  //     console.log('API Output',data)
     

  //   })
  // }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
}

